import gql from 'graphql-tag';

export const updateLanguagePreference = gql`
  mutation updateLanguagePreference($payload: CustomerLanguagePrefRequest!) {
    updateLanguagePreference(payload: $payload) {
      success
    }
  }
`;
